import { createSlice } from '@reduxjs/toolkit';

const initialState = {
    isActiveIndex: 0
};

const activeTabSlice = createSlice({
    name: "activeTabSlice",
    initialState,
    reducers: {
        setActiveTab: ((state, { payload }) => {
            console.log("payload active", payload)
            state.isActiveIndex = payload
        })
    }
});

export const { setActiveTab } = activeTabSlice.actions;
export default activeTabSlice.reducer;